var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("新增寻样申请")]),_c('OutsideApplySample',{ref:"outsideApplySample",on:{"on-success":_vm.cancelBtn,"cancel-btn":_vm.cancelBtn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }